/** Datos locales de Bordona que no deben mezclarse entre cuentas en el mismo navegador. */
const SESSION_KEYS = [
  "bordona-student-profile",
  "bordona-teacher-id",
  "bordona-skip-register",
] as const;

export function clearBordonaSessionCache(): void {
  try {
    for (const key of SESSION_KEYS) {
      localStorage.removeItem(key);
    }
  } catch {
    /* ignore */
  }
}
